import { render } from "./AdminTicketConversation.vue?vue&type=template&id=84a726d6&scoped=true"
import script from "./AdminTicketConversation.vue?vue&type=script&lang=js"
export * from "./AdminTicketConversation.vue?vue&type=script&lang=js"

import "./AdminTicketConversation.vue?vue&type=style&index=0&id=84a726d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a726d6"]])

export default __exports__